import { Box, styled } from "@mui/material";

export const BackgroundBox = styled(Box)({
  backgroundImage: 'url("/background.jpg")',
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0 20px",
});
